export default
function window(state = {
  courseScrollTop: 0
}, action) {
  switch(action.type) {
    case 'SET_LESSON_HEIGHT':
      return Object.assign({}, state, {
        lessonHeight: action.lessonHeight
      });
  case 'RESIZE_WINDOW':
    return Object.assign({}, state, {
      windowWidth: action.windowWidth,
      windowHeight: action.windowHeight
    });
    case 'SCROLL_COURSE_WINDOW':
      return Object.assign({}, state, {
        courseScrollTop: action.scrollTop
      });
    default:
      return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/window.js